import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { Box, Modal, Typography } from "@mui/material";

function DeleteHotel({ open, handleClose, handleDelete }) {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={webStyle.style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={webStyle.modalTitle}
        >
          Delete Hotel Brand
        </Typography>
        <Typography variant="body1" style={webStyle.modalSubTitle}>
          Are you sure you want to delete this Hotel?
        </Typography>

        <Box
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Button
            onClick={handleClose}
            color="primary"
            style={webStyle.cancelBtn}
          >
            Cancel
          </Button>
          <Button onClick={handleDelete} style={webStyle.saveBtn}>
            Delete
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

DeleteHotel.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default DeleteHotel;
const webStyle = {
  style: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // width: "90%",
    width: { xs: "90%", sm: "450px" },
    bgcolor: "background.paper",
    borderRadius: 1,
    boxShadow: 24,
    p: 3,
  },
  modalTitle: {
    paddingBottom: "10px",
    fontSize: "23px",
  },
  modalSubTitle: {
    paddingBottom: "20px",
    color: "gray",
    fontSize: "15px",
  },
  cancelBtn: {
    backgroundColor: "white",
    border: "1px solid green",
    color: "green",
    padding: "8px 22px",
  },
  saveBtn: {
    backgroundColor: "green",
    border: "1px solid green",
    color: "white",
    padding: "8px 22px",
  },
};
